import { Link } from "react-router-dom";
import { articles } from "@/mocks/news";

export default function SpotlightSection() {
  const featured = articles.find((item) => item.rank === 1) ?? articles[0];
  const secondary = articles
    .filter((item) => item.id !== featured.id)
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 5);

  return (
    <section className="mx-auto max-w-site px-4 py-14 md:px-6 md:py-16" aria-labelledby="spotlight-title">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-medium tracking-[0.2em] text-primary-600">TODAY&apos;S FOCUS</p>
          <h2 id="spotlight-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            今日焦点
          </h2>
        </div>
        <Link
          to="/#today-feed"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          查看全部速递
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <article className="group relative overflow-hidden rounded-lg lg:col-span-8">
          <Link to={`/article/${featured.id}`} className="block">
            <div className="relative h-[320px] w-full overflow-hidden md:h-[440px]">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - 看瓜爆料`}
                className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/50 to-transparent"></div>
            </div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                  热度榜 TOP 1
                </span>
                <span className="rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-900">
                  {featured.category}
                </span>
                <span className="text-xs text-background-300">{featured.timeLabel}</span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-black leading-snug text-background-50 md:text-3xl">
                {featured.title}
              </h3>
              <p className="mt-3 line-clamp-2 max-w-3xl text-sm leading-relaxed text-background-200">
                {featured.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-300">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true"></i>
                  {(featured.views / 10000).toFixed(1)} 万阅读
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line" aria-hidden="true"></i>
                  {featured.comments} 条讨论
                </span>
                <span className="hidden items-center gap-1 sm:flex">
                  <i className="ri-file-list-3-line" aria-hidden="true"></i>
                  {featured.tags.join(" / ")}
                </span>
              </div>
            </div>
          </Link>
        </article>

        <div className="rounded-lg border border-background-200 bg-background-100 p-5 lg:col-span-4">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <i className="ri-list-check-2 text-lg text-primary-600" aria-hidden="true"></i>
            正在发酵的话题
          </h3>
          <ol className="mt-4 space-y-1">
            {secondary.map((item, index) => (
              <li key={item.id}>
                <Link
                  to={`/article/${item.id}`}
                  className="group flex items-start gap-3 border-b border-background-200 py-3 last:border-0"
                >
                  <span className="font-heading text-lg font-black text-background-400">
                    {String(index + 2).padStart(2, "0")}
                  </span>
                  <span className="min-w-0">
                    <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="mt-1 block text-xs text-foreground-500">
                      {item.category} · {item.timeLabel}
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}